import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const IframeWrapper = styled.div`
  width: ${props => props.width || '100vw'};
  height: ${props => props.height || '100%'};
  min-height: ${props => props.minHeight || props.height || '100vh'};
  overflow: hidden;
`;

function Iframe({ src, width, height, minHeight, title, ...rest }) {
  return (
    <IframeWrapper width={width} height={height} minHeight={minHeight}>
      <iframe
        // key ensures React fully recreates the iframe when src changes.
        key={src}
        title={title || src}
        width="100%"
        height="100%"
        src={src}
        style={{ border: 0 }}
        // Survey providers often need these capabilities.
        allow="fullscreen; autoplay; clipboard-read; clipboard-write"
        // If the provider checks Referer, don't strip it.
        referrerPolicy="no-referrer-when-downgrade"
        {...rest}
      />
    </IframeWrapper>
  );
}

Iframe.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  minHeight: PropTypes.string,
  title: PropTypes.string,
  src: PropTypes.string.isRequired
};

export default Iframe;
